export default __webpack_public_path__ + "static/2-7878e8a9fdc29932cd33d81a7fbb7ef2.webp";